import { render, staticRenderFns } from "./CockpitLineVerticalSelectorItem.vue?vue&type=template&id=615b74c9&scoped=true"
import script from "./CockpitLineVerticalSelectorItem.vue?vue&type=script&lang=js"
export * from "./CockpitLineVerticalSelectorItem.vue?vue&type=script&lang=js"
import style0 from "./CockpitLineVerticalSelectorItem.vue?vue&type=style&index=0&id=615b74c9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615b74c9",
  null
  
)

export default component.exports